import service from '@api/config'

// 根据地区编码分页获取工伤预防推荐项目 参数 cityId
export const listRecommend = (data) => {
  return service.request({
    url: `/injury/prevent/project/recommend`,
    method: 'post',
    data: data
  })
}

// 根据地区编码分页获取工伤预防非推荐项目列表 参数 cityId
export const list = (data) => {
  return service.request({
    url: `/injury/prevent/project/list`,
    method: 'post',
    data: data
  })
}

// 根据项目id分页获取工伤预防课程列表 参数 projectId
export const listCourse = (data) => {
  return service.request({
    url: `/injury/prevent/course/list`,
    method: 'post',
    data: data
  })
}

// 根据项目id分页获取工伤预防最近课程列表 参数 projectId
export const listRecent = (data) => {
  return service.request({
    url: `/injury/prevent/course/recent/list`,
    method: 'post',
    data: data
  })
}

// 根据项目id,课程id查询课程详情 参数 projectId,courseId
export const getDetail = (data) => {
  return service.request({
    url: `/injury/prevent/course/detail`,
    method: 'post',
    data: data
  })
}

// 记录项目课程学习进度
// 参数 projectId,courseId,currentRate(当前进度)，
// currentDuration（当前播放时长（秒）），
// recordId（播放记录id，第一次播放没有，接口调用后返回，下次调用接口带上）
export const playRecord = (data) => {
  return service.request({
    url: `/injury/prevent/play/record`,
    method: 'post',
    data: data
  })
}

// 学习报表  参数：timeType（0-全部；1-近7天；2-近1月；3-近3月）
export const studyReport = (data) => {
  return service.request({
    url: `/injury/prevent/study/report`,
    method: 'post',
    data: data
  })
}
